/* eslint-disable max-len */
 
const React = require('react')
const PropTypes = require('prop-types')
const Profile = require('./profile')
const Error404Page = require('page/error/404')

class ValidateMapped extends React.Component {

    // return components used in render method
    components() {
        return {
            Profile,
            Error404Page,
        }
    }

    render() {
         
        const { Profile, Error404Page } = this.components()
        const { mapped_disabled } = this.context.page
        const { DOMAIN_NAME_URL } = this.context.globals
        const account_settings_href = `${DOMAIN_NAME_URL}/user/edit/account/`
        const support_href = 'https://support.about.me/'

        const nav_props = {
            logo_href: 'https://about.me',
            render_signup: false,
            render_login: false,
        }

        if (mapped_disabled) {
            return (
                <Error404Page nav_props={nav_props}>
                    <p>
                        If this is your domain, please check your <a href={account_settings_href}>account settings</a> or <a href={support_href}>contact support</a>.
                    </p>
                </Error404Page>
            )
        } else {
            return (
                <Profile />
            )
        }
    }

}

ValidateMapped.contextTypes = {
    page: PropTypes.object.isRequired,
    globals: PropTypes.object.isRequired,
}

module.exports = ValidateMapped
